import { render, staticRenderFns } from "./Favorite_button.vue?vue&type=template&id=c71fc732&scoped=true&"
import script from "./Favorite_button.vue?vue&type=script&lang=js&"
export * from "./Favorite_button.vue?vue&type=script&lang=js&"
import style0 from "./Favorite_button.vue?vue&type=style&index=0&id=c71fc732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71fc732",
  null
  
)

export default component.exports